import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// Types
import uppercase from '@drivesally/sally-fw/lib/type/types/uppercase.type';

export default attribute({
  type: TEXT,
  attribute: 'home_station',
  display: uppercase,
  input: uppercase,
  api: uppercase,
  label: {
    default: 'Home Station',
    short: 'Home Station',
  },
});
